import Profile from "views/Profile.js";
import Login from "views/Login.js";
import Master from "views/Master";
import AdminListing from "views/AdminListing";
import Report from "views/Report.js";
import DownloadMultipleReoprts from "utils/DownloadMultipleReoprts";
import VendorListing from "views/vendor/VendorListing";
import SchoolList from "views/vendor/SchoolList";
import School from "views/School/School";

const routes = [
  
  {
    path: "/user",
    name: "Users Listing",
    icon: "fas fa-user text-white",
    component: <Master />,
    layout: "/admin",
    show: true,
  },

  {
    path: "/vendor",
    name: "Vendor Listing",
    icon: "fas fa-user-tie text-green",
    component: <VendorListing />,
    layout: "/admin",
    show: true,
  },

  {
    path: "/school",
    name: "School Listing",
    icon: "fas fa-book-reader text-orange",
    component: <School />,
    layout: "/admin",
    show: true,
  },

  {
    path: "/user/adminListing",
    name: "Admins From User",
    component: <AdminListing />,
    layout: "/admin",
    show: false,
  },

  {
    path: "/vendor/school-listing/:id",
    name: "Vendor School List",
    component: <SchoolList />,
    layout: "/admin",
    show: false,
  },

  {
    path: "/vendor/school-listing/:id/adminListing",
    name: "Admins From Vendor",
    component: <AdminListing />,
    layout: "/admin",
    show: false,
  },

  {
    path: "/school/adminListing",
    name: "Admins From School",
    component: <AdminListing />,
    layout: "/admin",
    show: false,
  },

  {
    path: "/:parent/index/user-profile/:id",
    name: "User Profile",
    component: <Profile />,
    layout: "/admin",
    show: false,
  },

  {
    path: "/index/user-profile/multiple-reports",
    name: "Multiple Reports",
    component: <DownloadMultipleReoprts />,
    layout: "/admin",
    show: false,
  },

  {
    path: "/:parent/index/user-profile/report/:id",
    name: "Report",
    component: <Report />,
    show: false,
    layout: "/admin",
  },

  {
    path: "/login",
    name: "Login",
    component: <Login />,
    layout: "/auth",
    show: false,
  },
];

export default routes;
